
import { SchoolPersonalModel } from "@/models/academy.model";
import { School } from "@/models/academy.types";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({})
export default class PersonalInfo extends Vue {
  // ACTIONS

  // STATE
  @State("school_personal", { namespace: "academy" })
  private school_personal: SchoolPersonalModel;

  // WATCH
  @Watch("school_personal.full_name")
  private onChangeFullName(full_name: string) {
    if (full_name) {
      localStorage.setItem("full_name", full_name);
    }
  }

  @Watch("school_personal.position")
  private onChangePosition(position: string) {
    if (position) {
      localStorage.setItem("position", position);
    }
  }

  @Watch("school_personal.email")
  private onChangeEmail(email: string) {
    if (email) {
      localStorage.setItem("email", email);
    }
  }

  @Watch("school_personal.phone")
  private onChangePhone(phone: string) {
    if (phone) {
      localStorage.setItem("phone", phone);
    }
  }

  // LIFECYCLE
  private created() {
    const full_name = localStorage.getItem("full_name");
    const position = localStorage.getItem("position");
    const email = localStorage.getItem("email");
    const phone = localStorage.getItem("phone");
    if (full_name !== null) {
      this.$store.state.academy.school_personal.full_name = full_name;
    }
    if (position !== null) {
      this.$store.state.academy.school_personal.position = position;
    }
    if (email !== null) {
      this.$store.state.academy.school_personal.email = email;
    }
    if (phone !== null) {
      this.$store.state.academy.school_personal.phone = phone;
    }
  }
}
